module.exports = __webpack_public_path__ + "static/media/brush.cf5df6a8.svg";